<template>

    <div>

        <table class="table w-100 table-inbox">
           <thead>
             <tr class="border-bottom msgToolbar">
               <td><b-form-checkbox v-model="selectAll" :value="true" class="mt-2"></b-form-checkbox></td>
               <td scope="col"><h3 class="m-0 p-0 mt-1" v-if="currentFolder.name">{{ translateFolderName(currentFolder) }}</h3></td>
               <td scope="col" colspan="2">
                   <div class="btn-group mr-3">
                       <router-link :to="{ name: 'messages.compose' }" tag="button" class="btn btn-outline-otu border">
                           <font-awesome-icon class="mr-1" :icon="['far', 'edit']" />
                           <span class="d-none d-lg-inline-block ml-2">{{ $t('messages.compose_button') }}</span>
                       </router-link>
                       <button class="btn btn-outline-otu border" v-b-modal.modalDeleteMsgs :disabled="selectedMessages.length == 0">
                           <font-awesome-icon class="mr-1" :icon="['far', 'trash-alt']" />
                           <span class="d-none d-lg-inline-block ml-2">{{ $t('messages.delete_button') }}</span>
                       </button>
                       <button type="button" class="btn btn-outline-otu border" @click="restoreMessage()" v-if="currentFolder.type_id == 10" :disabled="selectedMessages.length == 0">
							<font-awesome-icon class="mr-1" :icon="['fas', 'undo']" />
                            <span class="d-none d-lg-inline-block ml-2">{{ $t('messages.undelete') }}</span>
                        </button>
                   </div>
                   <div class="btn-group" v-if="currentFolder.type_id != 10">
                       <button class="btn btn-outline-otu border" data-toggle="dropdown" :disabled="selectedMessages.length == 0">
                           <font-awesome-icon class="mr-1" :icon="['fas', 'arrows-alt']" />
                           <span class="d-none d-lg-inline-block ml-2">{{ $t('messages.move_button') }}</span>
                           <font-awesome-icon class="ml-1" :icon="['fas', 'angle-down']" />
                       </button>
                       <div class="dropdown-menu">
							<span v-for="folder in movableFolders" class="dropdown-item" :key="folder.id" @click="moveSelectedMessages(folder.id)"><font-awesome-icon class="mr-1" :icon="['far', 'folder-open']" />{{ translateFolderName(folder) }}</span>
						</div>
                   </div>
               </td>
             </tr>
           </thead>
           <tbody>
             <tr v-for="msg in messages" :key="msg.id" :class="((!msg.read_at) ? 'unread' : 'read')+' msg'">
               <td><b-form-checkbox ref="msgSelect" v-model="selectedMessages" :value="msg.id" class="msgSelect"></b-form-checkbox>
               <td @click="clickMessage(msg)" class="align-middle table-inbox-from">{{msg.sender.first_name}} {{msg.sender.last_name}}</td>
               <td @click="clickMessage(msg)" class="table-inbox-subject"><div class="subject">{{msg.subject}}</div>
                   <span class="text-muted font-weight-normal bodypreview" v-html="$options.filters.bodyPreview(msg.body)+'...'"></span>
               </td>
               <td @click="clickMessage(msg)" class="text-nowrap align-middle table-inbox-time">
                   <span v-if="msg.sent_at" class="time">{{msg.sent_at | formatdate}}</span>
               </td>
             </tr>
             <tr>
                 <td v-if="messages.length == 0" colspan="4"><em>{{ $t('messages.no_messages') }}</em></td>
             </tr>
           </tbody>
         </table>

         <b-pagination v-if="messageCount > per_page" size="md" :total-rows="messageCount" v-model="page" :per-page="per_page" align="center" class="m-2 mt-4"></b-pagination>

        <!-- Modal -->
		<b-modal id="modalDeleteMsgs" :title="$t('messages.delete_confirm_title')" size="md" :ok-title="$t('delete_button')" :cancel-title="$t('cancel_button')" centered @ok="removeMessages">
			{{ $t('messages.delete_confirm_msg') }}
		</b-modal>

    </div>

</template>

<script>

import { mapActions, mapGetters } from 'vuex'

// Common OTU Components
import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { mapCommonFilters } from '@/lib/filters.js';
import { errHandler } from '@/lib/handlers'

export default {
	name: 'MessagesListing',
	data () {
		return {
			selectedMessages: [],
            selectAll: false,
            page: 1
		}
	},
	filters: {
		...mapCommonFilters,
	},
	created () {
		this.buildMessageList(this.$route.params.id);
	},
	computed: {
		...mapGetters(['currentUserId', 'messages']),
        folderId () {
			return this.$route.params.id;
		},
		currentFolder () {
			if (this.$store.state.messages.folders.length > 0) {
				return this.$store.state.messages.folders.find( (folder) => {
					return folder.id == this.$route.params.id;
				});
			} else return {name: '', unread_count: 0};
		},
		messages () {
			return _.orderBy(this.$store.state.messages.messages, 'sent_at', 'desc');
		},
		movableFolders () {
			if (this.$store.state.messages.folders.length > 0) {
				let flds = [];
				let vm = this;
				this.$store.state.messages.folders.forEach(function (value, key) {
					if ((value.type_id == 40 || value.type_id == 0) && vm.currentFolder.id != value.id && value.parent_folder_id == null ) flds.push(value);
				});
				return flds;
			}
			return [];
		},
        messageCount () {
            return this.$store.state.messages.message_count;
		},
		per_page () {
            return 25;
		}
	},
	watch: {
		$route ({params, query}) {
			this.buildMessageList(params.id);
			this.fetchFolders();
            this.selectedMessages = [];
		},
        selectAll (checked) {
            if (checked) {
                let selected = []
                $('.msgSelect input').each(function() {
                    selected.push( $(this).val() );
                });
                this.selectedMessages = selected;
            } else this.selectedMessages = [];
        },
        'page': {
             handler () {
                 this.buildMessageList();
            }
        }
	},
	methods: {
		...mapActions([ 'fetchFolders', 'fetchMessages', 'delMessage', 'moveMessages', 'unDeleteMessage' ]),
		...mapNotificationEventActions,
		buildMessageList () {
			this.fetchMessages({folderid: this.folderId, page: this.page, per_page: this.per_page}).catch( (err) => errHandler(err) );
		},
		clickMessage (msg, event) {
			if (this.currentFolder.type_id == 20) this.$router.push({ name: 'messages.draft', params: { id: msg.id } });
			else this.$router.push({ name: 'messages.read', params: { folder_id: msg.folder_id, id: msg.id } });
		},
		removeMessages () {

            let promises = [];
			for (let index = 0; index < this.selectedMessages.length; index++) {
				let msgId = this.selectedMessages[index];
				let fldId = this.$store.state.messages.messages[msgId].folder_id;
				promises.push(this.delMessage({ folderId: fldId, messageId: msgId }));
			}

			promises.push(this.fetchFolders());
			Promise.all(promises).then((vs) => {
			    let msg = (promises.length > 2) ? this.$t('messages.messages.msgs_deleted') : this.$t('messages.messages.msg_deleted');
				this.emitSuccess({msg: msg});
			}).catch( (errors) => {
				errors.forEach((err, key) => errHandler(err) );
			});

			this.selectedMessages = [];

		},
		restoreMessage () {

            if (this.selectedMessages.length > 0) {

    			for (let index = 0; index < this.selectedMessages.length; index++) {
    				let msgId = this.selectedMessages[index];
    				let fldId = this.$store.state.messages.messages[msgId].folder_id;
    				this.unDeleteMessage({ folderId: fldId, messageId: msgId })
    					.then((e) => {
    					      this.emitSuccess({msg: this.$t('messages.messages.undeleted') });
    					}).catch( (err) => errHandler(err));
    			}
    		    this.fetchFolders();
    		    this.selectedMessages = [];

            } else this.emitInfo({ msg: this.$t('messages.messages.none_selected') });
		},
		moveSelectedMessages (destFolderId) {

            if (this.selectedMessages.length > 0) {

                this.moveMessages({ folderId: this.currentFolder.id, destFolderId: destFolderId, messages: this.selectedMessages}).then((v) => {
                    this.emitSuccess({msg: this.$t('messages.messages.moved') });
                    this.fetchFolders();
                }).catch( (err) => errHandler(err) );

                this.selectedMessages = [];

            } else this.emitInfo({ msg: this.$t('messages.messages.none_selected') });
		},
        translateFolderName (folder) {
            return (folder.type_id > 0) ? this.$t('messages.folders.'+folder.type_id) : folder.name;
        }
	}
}
</script>
